import { render, staticRenderFns } from "./WorkSelect.vue?vue&type=template&id=c0965dc4&scoped=true"
import script from "./WorkSelect.vue?vue&type=script&lang=js"
export * from "./WorkSelect.vue?vue&type=script&lang=js"
import style0 from "./WorkSelect.vue?vue&type=style&index=0&id=c0965dc4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0965dc4",
  null
  
)

export default component.exports